// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DWcUVahhJRLbQL {
  margin-bottom: var(--ds-space-400, 32px);
  font-size: medium;
  text-align: center;
}
.sAD8jWCGopzpqF {
  display: flex;
}
.wOSkK4eZfGeCLL {
  color: var(--ds-text-subtle, #44546f);
  font-size: small;
}
.IKtmfGsMSfex2O {
  margin-left: auto;
  color: var(--ds-link, #0c66e4);
  font-size: medium;
  text-decoration: none;
}
.IKtmfGsMSfex2O:hover {
  text-decoration: underline;
}
.KjiLSeE_ySQpg7 {
  display: flex;
  align-items: center;
  margin-top: var(--ds-space-050, 4px);
  margin-bottom: 28px;
}
.GI52wdK_b7PFjZ {
  flex-shrink: 0;
  margin-right: var(--ds-space-150, 12px);
}
.vAbrIavKW0AJUa {
  color: var(--ds-text, #172b4d);
  font-size: medium;
  overflow-wrap: anywhere;
}
.H7Gdxlh8gLIAyi {
  color: var(--ds-text-subtle, #44546f);
}
.RK1sReMc8R149J {
  margin-bottom: var(--ds-space-200, 16px);
  color: var(--ds-text-subtlest, #626f86);
  font-size: small;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `DWcUVahhJRLbQL`,
	"displayFlex": `sAD8jWCGopzpqF`,
	"loginAsTitle": `wOSkK4eZfGeCLL`,
	"switchAccountLink": `IKtmfGsMSfex2O`,
	"memberInfoContainer": `KjiLSeE_ySQpg7`,
	"memberAvatar": `GI52wdK_b7PFjZ`,
	"fullName": `vAbrIavKW0AJUa`,
	"email": `H7Gdxlh8gLIAyi`,
	"footerText": `RK1sReMc8R149J`
};
export default ___CSS_LOADER_EXPORT___;
